export default "__VITE_ASSET__D12FCA$n__"